module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.3dd91d48.webp";